namespace GeniuzPOS.InitialData {
    export enum LinkCodeFg {
        LinkCodeFgPlu = 1,
        LinkCodeFgStyle = 2
    }
    Serenity.Decorators.registerEnumType(LinkCodeFg, 'GeniuzPOS.InitialData.LinkCodeFg');
}
